import { IconButton, styled } from '@mui/material'

export const OutlinedIconButton = styled(IconButton)(({ theme }) => ({
  border: '1px solid',
  borderColor: 'rgba(64, 64, 64, 0.5)',
  backgroundColor: 'transparent',
  borderRadius: theme.shape.borderRadius,
  '&:hover': {
    backgroundColor: 'rgba(64, 64, 64, 0.04)',
    borderColor: 'rgba(64, 64, 64, 0.75)',
  },
}))
